<ng-container *transloco="let t">
  <div class="flex-column-center p2">
    <span class="onboarding-title"><strong>{{ t('GENERIC_WRAPPER.ON_BOARDING_REQUIRED_TITLE')}}</strong></span>
    <p class="onboarding-text">{{ t('GENERIC_WRAPPER.ON_BOARDING_REQUIRED_TEXT')}}</p>
    <button mat-dialog-close class="w-100 onboarding-button" type="submit" mat-flat-button color="primary" (click)="onClickStartOnboarding()">{{ t('GENERIC_WRAPPER.ON_BOARDING_REQUIRED_BUTTON')}}</button>
  </div>
</ng-container>
